module.exports = __webpack_public_path__ + "img/tr.51ef07be.svg";